/**
 * API-контракты для управления пользователями (admin).
 *
 * Этот файл описывает Zod-схемы для user management эндпоинтов.
 * При реализации — перенести в packages/shared/src/contracts/users.ts
 */
import { z } from "zod";
import { UserRoleEnum, UserStatusEnum } from "./auth";
// ─── Login validation (FR-018) ───────────────────────────────────────────────
const LOGIN_REGEX = /^[a-zA-Z0-9_-]{3,30}$/;
// ─── User Schema (list/detail response) ──────────────────────────────────────
export const UserSchema = z.object({
    id: z.number(),
    login: z.string(),
    displayName: z.string(),
    role: UserRoleEnum,
    status: UserStatusEnum,
    createdAt: z.string().datetime(),
    lastLoginAt: z.string().datetime().nullable(),
});
// ─── Create User ─────────────────────────────────────────────────────────────
/** POST /api/users — request (admin only) */
export const CreateUserRequestSchema = z.object({
    login: z.string().regex(LOGIN_REGEX, "Логин: латиница, цифры, - и _, от 3 до 30 символов"),
    displayName: z.string().min(1).max(100),
    password: z.string().min(8),
    role: UserRoleEnum.default("user"),
});
/** POST /api/users — response 201 */
export const CreateUserResponseSchema = z.object({
    user: UserSchema,
});
/** POST /api/users — response 409 (логин занят) */
export const LoginConflictErrorSchema = z.object({
    error: z.literal("LOGIN_TAKEN"),
    message: z.string(),
});
// ─── List Users ──────────────────────────────────────────────────────────────
/** GET /api/users — query params */
export const ListUsersQuerySchema = z.object({
    status: UserStatusEnum.optional(),
    role: UserRoleEnum.optional(),
});
/** GET /api/users — response 200 */
export const ListUsersResponseSchema = z.object({
    users: z.array(UserSchema),
    total: z.number(),
});
// ─── Update User ─────────────────────────────────────────────────────────────
/** PATCH /api/users/:id — request (admin only) */
export const UpdateUserRequestSchema = z.object({
    displayName: z.string().min(1).max(100).optional(),
    role: UserRoleEnum.optional(),
    status: UserStatusEnum.optional(),
});
/** PATCH /api/users/:id — response 200 */
export const UpdateUserResponseSchema = z.object({
    user: UserSchema,
});
// ─── Reset Password ──────────────────────────────────────────────────────────
/** POST /api/users/:id/reset-password — request (admin only) */
export const ResetPasswordRequestSchema = z.object({
    newPassword: z.string().min(8),
});
/** POST /api/users/:id/reset-password — response 200 */
export const ResetPasswordResponseSchema = z.object({
    success: z.literal(true),
});
// ─── Error: Last Admin Protection ────────────────────────────────────────────
/** response 422 — при попытке деактивировать последнего админа */
export const LastAdminErrorSchema = z.object({
    error: z.literal("LAST_ADMIN"),
    message: z.string(),
});
//# sourceMappingURL=users.js.map